module.exports = __webpack_public_path__ + "static/media/logout.db9fe566.svg";